import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { MST1060_R10Dto } from "./Dto_MST1060_R10";
import { MST1060_R10Filter } from "./Store_MST1060_R10";

const barcodeUrl = `${config.apiUrl}/MST1060_R10`;


const getParams = (filter: MST1060_R10Filter, listLength?: number) => {	
	return {
		brandCd: filter.brandCd || '',
		itemGroup: filter.itemGroup || '',
		itemAccount: filter.itemAccount || '',
		searchText: filter.searchText || '',
		itemCd: filter.itemCd || '',
		itemNm: filter.itemNm || '',
		listLength: listLength || 0
	}
}

/**
 * 바코드 목록 조회
 * @param params
 * @param listLength
 */
export const getMST1060_R10List = async (params: MST1060_R10Filter, listLength: number = 0) => {

	return await getData<ResponseDto<MST1060_R10Dto[]>>(barcodeUrl, { params: getParams(params, listLength) });
}

/**
 * 바코드 등록
 * @param data 바코드 데이터 배열
 */
export const createMST1060_R10Batch = async (data: MST1060_R10Dto[]) => {
	return await postData<MST1060_R10Dto[], ResponseDto<MST1060_R10Dto[]>>(barcodeUrl, data);
};

/**
 * 바코드 수정
 * @param data 바코드 데이터
 */
export const patchMST1060_R10 = async (data: MST1060_R10Dto) => {
	return await patchData<MST1060_R10Dto, ResponseDto<MST1060_R10Dto>>(barcodeUrl, data);
};

/**
 * 바코드  삭제
 * @param barcodes 바코드 배열
 */
export const deleteMST1060_R10Batch = async (barcodes: string[]) => {
	return await deleteData<ResponseDto<any>>(barcodeUrl, { data: barcodes });
};

/**
 * 엑셀 다운로드
 * @param searchText 검색어
 */
export const downloadExcel_MST1060_R10 = async (searchText?: string) => {
	const url = `${barcodeUrl}/excel`;
	return await getData<ResponseDto<string>>(url, {
		params: {
			searchText
		}
	});
};

